module.exports = __webpack_public_path__ + "img/nodatas.21103b69.png";